export const DEFAULT_CALENDAR_MONTH_VISIT_LIMIT = 1000;
export const DEFAULT_CALENDAR_WEEK_VISIT_LIMIT = 500;
export const DEFAULT_CALENDAR_DAY_MAX_EVENTS = 4;
export const DEFAULT_SERIES_START_HOUR = 7;
